import { autorun, IObservableValue } from "mobx";
import * as React from "react";
import { partialAPI } from "../api";
import { CvpSettings } from "../api/settings/CvpSettings";
import { DEFAULT_SETTINGS } from "../api/settings/DefaultCvpSettings";
import { CvpLocale } from "./getIdLanguage";
import { lp } from "./logPrefix";
import {
  PostMessageCVPEmbedHasMounted,
  PostMessageTypes,
} from "./PostMessageTypes";
import { redirect } from "./urlUtils";
import { useComputed } from "./useComputed";
import { createUserInfoContext } from "./UserInfo";
import { removeNull } from "./util";
import { CVPSearchParams, queryStringStore } from "./wsQueryStringStore";

export const apiOverrides: partialAPI = {};

export const useUserInfoBase = (settings: IObservableValue<CvpSettings>) => {
  React.useEffect(() => {
    const idEmbed = settings.get().idEmbed;

    if (!idEmbed) return;
    if (idEmbed === "cvWebtempNo") return;

    const msg: PostMessageCVPEmbedHasMounted = {
      type: PostMessageTypes.CVPEmbedHasMounted,
    };

    console.log(lp("window.parent.postMessage"), msg);
    window.parent.postMessage(msg, "*");
  }, []);

  const mergedSettings = useComputed(() => {
    const defaultSettings = removeNull(DEFAULT_SETTINGS);
    const propSettings = removeNull(settings.get() || {});

    return {
      ...defaultSettings,
      ...propSettings,
    } as CvpSettings;
  });

  const userInfo = React.useMemo(() => {
    return createUserInfoContext(() => ({
      get settings() {
        console.log(mergedSettings.get);
        return mergedSettings.get;
      },
      get idConcern() {
        return Number(mergedSettings.get.idConcern);
      },
      get locale() {
        const localeFromQs =
          queryStringStore.qs[CVPSearchParams.cvplocale]?.toString();

        if (localeFromQs) {
          const isValid = Object.values(CvpLocale).includes(
            localeFromQs as CvpLocale
          );

          if (isValid) {
            return localeFromQs as CvpLocale;
          }

          console.error("Invalid locale from query string", localeFromQs);
        }
        return mergedSettings.get.locale;
      },
      loc: (s) => s,
      api: apiOverrides,
      firmCandidates: null,
      reactCvEditor: true,
    }));
  }, []);

  // React.useEffect(() => {
  //   const listener = action((event: StorageEvent) => {
  //     if (event.key !== "userToken") return;

  //     if (event.storageArea !== storageArea) return;

  //     userInfo.setToken(JSON.parse(storageArea.getItem("userToken") ?? "null"));
  //   });

  //   window.addEventListener("storage", listener, false);

  //   (window as any).cvpLogOut = action(() => {
  //     userInfo.setToken(null);
  //   });

  //   return () => {
  //     window.removeEventListener("storage", listener);
  //   };
  // }, []);

  React.useEffect(() => {
    let lastStartPage = userInfo.settings.startPage;

    const disposer = autorun(() => {
      const newStartPage = userInfo.settings.startPage;
      const changed = lastStartPage !== newStartPage;
      lastStartPage = newStartPage;

      if (changed) {
        redirect(newStartPage, { userInfo, mergeQs: {} });
      }
    });

    return disposer;
  }, []);

  return userInfo;
};
